import React from 'react';

export const QualificationSection = () => {
  return (
    <section className="section-wrap">
      <div className="section-inner">
        <div className="section-label">Qualification</div>
        <div className="section-title">This offer is for a specific audience.</div>
        <div className="section-sub">The 75 copies are reserved for HR leaders who can put the frameworks to work at scale.</div>
        
        <div className="who-grid">
          <div className="who-box who-yes">
            <div className="who-header">This is for you if</div>
            <div className="who-item">You lead or co-lead HR at an organisation with 1,000+ employees in India</div>
            <div className="who-item">Your title carries functional accountability — CHRO, CPO, VP HR, Head of HR, or Director</div>
            <div className="who-item">You are evaluating, piloting, or scaling AI within your HR operations</div>
            <div className="who-item">You present to the CEO, CFO, or Board on HR outcomes</div>
          </div>

          <div className="who-box who-no">
            <div className="who-header">This is not for</div>
            <div className="who-item">HR technology vendors or consultants (the book will be available for purchase at launch)</div>
            <div className="who-item">Academics or researchers (resources will be available on the companion website)</div>
            <div className="who-item">Individual contributors or early-career professionals (the book assumes functional leadership)</div>
            <div className="who-item">Organisations outside India (author copies ship domestically only)</div>
          </div>
        </div>
      </div>
    </section>
  );
};
